import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../../layouts/shared-service';
import { AnalysisDetails } from '../../model/analysis-details.model';
import { DropDownService } from '../../service/drop-down.service';
import { UploadService } from '../../service';
import moment from 'moment';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-new-analysis',
  templateUrl: './new-analysis.component.html',
  styleUrls: ['./new-analysis.component.scss']
})
export class NewAnalysisComponent implements OnInit {
  pageTitle = 'Analyze Report/Data';
  analysisFormGroup?: FormGroup;
  disableMatPanelValue?: boolean;
  analysistype_value?: string;
  analysisDetails?: AnalysisDetails;
  editDetails?: AnalysisDetails;
  post: any = '';
  maxDate?: Date;
  modules?: { name: string; desc: string; }[];
  openSecondMatStep?: string;
  key: any = '';
  disabledValue?: boolean;

  constructor(private formBuilder: FormBuilder,
    private _sharedService: SharedService,
    private dropDownService: DropDownService,
    private uploadService: UploadService,
    private ref: ChangeDetectorRef) {
    this._sharedService.emitChange(this.pageTitle);
    this.uploadService.disabledValue.subscribe(res => {
      this.disabledValue = res;
    });
  }

  ngOnInit() {
    this.modules = environment.modules.values;
    this.createForm();
  }

  editform() {
    this.post = '';
    this.editDetails = this.analysisDetails;
  }


  editdetails(payload: any) {
    this.post = payload;
  }

  displaydetails(item: AnalysisDetails | undefined) {
    this.analysisDetails = item;
    this.post = this.analysisDetails;
    this.openSecondMatStep = this.analysisDetails?.analysisType;
  }

  disableMatPanel(item: boolean | undefined) {
    this.disableMatPanelValue = item;
  }

  createForm() {
    this.analysisFormGroup = this.formBuilder.group({
      analysisType: [null, Validators.required],
    });
    this.ref.detectChanges();
  }

  get formControls() { return this.analysisFormGroup?.controls; }
  resetAnalysis(event: string | undefined) {
    this.analysistype_value = '';
    this.analysistype_value = event;
  }

  getDisplayString(key: string) {
    return this.dropDownService.nameDescMap.get(key);
  }

  getDropDownValues(key: string) {
    return this.dropDownService.dropDownsMap.get(key);
  }
}
